import { render, staticRenderFns } from "./Update-Email.vue?vue&type=template&id=c22e9dc4&scoped=true&"
import script from "./Update-Email.vue?vue&type=script&lang=js&"
export * from "./Update-Email.vue?vue&type=script&lang=js&"
import style0 from "./Update-Email.vue?vue&type=style&index=0&id=c22e9dc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22e9dc4",
  null
  
)

export default component.exports